import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { IAssignmentType } from '../models/assignment-type';
import { AssignmentTypeService } from '../services/assignment-type.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentTypesResolver {
  constructor(
    private assignmentTypeService: AssignmentTypeService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IAssignmentType[]> {
    return this.assignmentTypeService.searchAssignmentTypes({ pageNumber: 0, pageSize: 999999 })
      .pipe(
        map(response => response.data)
      );
  }
}
